export default "__VITE_ASSET__0rcgdt0vBdA4Bvm_4Ma0zw__"